import { useState } from 'react';

const DAYS = ['S','M','T','W','T','F','S'];
const MONTHS = ['January','February','March','April','May','June',
                'July','August','September','October','November','December'];

export default function CalendarSidebar({ activeDates, selectedDate, onSelectDate, stats }) {
  const today = new Date();
  const [viewYear,  setViewYear]  = useState(today.getFullYear());
  const [viewMonth, setViewMonth] = useState(today.getMonth());

  function prevMonth() {
    if (viewMonth === 0) { setViewYear(y => y - 1); setViewMonth(11); }
    else setViewMonth(m => m - 1);
  }
  function nextMonth() {
    if (viewMonth === 11) { setViewYear(y => y + 1); setViewMonth(0); }
    else setViewMonth(m => m + 1);
  }

  const firstDay  = new Date(viewYear, viewMonth, 1).getDay();
  const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();

  function isToday(d) {
    return d === today.getDate() && viewMonth === today.getMonth() && viewYear === today.getFullYear();
  }
  function isSelected(d) {
    if (!selectedDate) return false;
    const s = new Date(selectedDate);
    return d === s.getDate() && viewMonth === s.getMonth() && viewYear === s.getFullYear();
  }
  function hasLeads(d) {
    const key = `${viewYear}-${String(viewMonth+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
    return activeDates.includes(key);
  }
  function handleClick(d) {
    const key = `${viewYear}-${String(viewMonth+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
    onSelectDate(key);
  }

  return (
    <div style={s.sidebar}>
      <div style={s.calHeader}>
        <button style={s.navBtn} onClick={prevMonth}>‹</button>
        <span style={s.monthLabel}>{MONTHS[viewMonth]} {viewYear}</span>
        <button style={s.navBtn} onClick={nextMonth}>›</button>
      </div>

      <div style={s.grid}>
        {DAYS.map((d,i) => <div key={i} style={s.dow}>{d}</div>)}
        {Array(firstDay).fill(null).map((_,i) => <div key={'e'+i}/>)}
        {Array.from({length: daysInMonth}, (_,i) => i+1).map(d => (
          <div
            key={d}
            onClick={() => handleClick(d)}
            style={{
              ...s.day,
              ...(isToday(d)    ? s.dayToday    : {}),
              ...(isSelected(d) ? s.daySelected : {}),
            }}
          >
            {d}
            {hasLeads(d) && (
              <span style={{
                ...s.dot,
                background: isToday(d) ? '#fff' : '#EF9F27',
              }}/>
            )}
          </div>
        ))}
      </div>

      <div style={s.divider}/>
      <div style={s.statRow}><span style={s.statL}>Leads due</span><span style={s.statV}>{stats.due}</span></div>
      <div style={s.statRow}><span style={s.statL}>Called</span><span style={s.statV}>{stats.called}</span></div>
      <div style={s.statRow}>
        <span style={s.statL}>Remaining</span>
        <span style={{...s.statV, color: stats.remaining > 0 ? '#854F0B' : '#3B6D11'}}>
          {stats.remaining}
        </span>
      </div>
      <div style={s.statRow}><span style={s.statL}>Interested</span><span style={{...s.statV, color:'#3B6D11'}}>{stats.interested}</span></div>
    </div>
  );
}

const s = {
  sidebar:   { width: 220, flexShrink: 0, background: '#fff', borderRight: '0.5px solid #E5E7EB', padding: 16 },
  calHeader: { display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom: 12 },
  monthLabel:{ fontSize: 13, fontWeight: 500, color: '#111827' },
  navBtn:    { width:22, height:22, border:'0.5px solid #E5E7EB', borderRadius:6, background:'transparent', cursor:'pointer', fontSize:14, color:'#6B7280', display:'flex', alignItems:'center', justifyContent:'center' },
  grid:      { display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:2, marginBottom:16 },
  dow:       { fontSize:10, color:'#9CA3AF', textAlign:'center', padding:'2px 0' },
  day:       { fontSize:11, textAlign:'center', padding:'5px 2px', borderRadius:4, cursor:'pointer', color:'#6B7280', position:'relative', userSelect:'none' },
  dayToday:  { background:'#1B3A5C', color:'#fff', fontWeight:500 },
  daySelected:{ background:'#DBEAFE', color:'#1B3A5C', fontWeight:500 },
  dot:       { width:4, height:4, borderRadius:'50%', position:'absolute', bottom:1, left:'50%', transform:'translateX(-50%)', display:'block' },
  divider:   { borderTop:'0.5px solid #E5E7EB', marginBottom:12 },
  statRow:   { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'5px 0', fontSize:12 },
  statL:     { color:'#6B7280' },
  statV:     { fontWeight:500, color:'#111827' },
};
